export default "__VITE_ASSET__6dw9dE7c__"